import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { musicianDefaultURL } from "../../../components/CommonApis/CommonArtistApis";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";

function AddPerformer() {

  const headers = getItemToken('access_token')

  const { id } = useParams()
  const [formData, setFormData] = useState(
    {
      artist_name: "",
      artist_slug: "",
      artist_email: "",
      description: ""
    })
  const [formDataError, setFormDataError] = useState({})
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [loading, setLoading] = useState(true)
  const [labelDisplay, setLabelDisplay] = useState([]);
  console.log(labelDisplay, 'labeldisplay')

  const titleInputRef = useRef(null);
  const slugInputRef = useRef(null);
  const emailRef = useRef(null)
  const coverImageRef = useRef(null)
  const navigate = useNavigate();
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;



  const handleAdd = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        formDataAdd[key] = formData[key];
      }
      const response = await axios.post(`${musicianDefaultURL?.storeApi}`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        if (coverImageFile) {
          await handleImageUpload(result?.artist_id)
        }
        setShowOverlay(false);
        toast.success(result?.message)
        navigate("/artists-musician");
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const handleUpdate = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (['artist_name', 'artist_slug', 'artist_email', 'description'].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }
      const response = await axios.post(`${musicianDefaultURL.updateApi}/${id}`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        if (coverImageFile) {
          await handleImageUpload(id)
        }
        setWithOutRefresh(!withOutRefresh)
        setShowOverlay(false);
        setCoverImageFile(null)
        toast.success(result?.message)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const handleImageUpload = async (id) => {
    try {
      const formData = new FormData();
      formData.append("artist_id", id);
      formData.append("image", coverImageFile);
      const response = await axios.post(`${musicianDefaultURL?.uploadImageApi}`, formData, { headers: headers });
      if (!response?.data?.status) {
        toast.error(response?.data?.message)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const handleStore = async () => {
    if (formValidation()) {
      if (!id) {
        await handleAdd();
      }
      else {
        handleUpdate()
      }

    } else {
      console.log("Form validation failed ");
    }
  }


  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.artist_name) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        artist_name: "Artist Musician cannot be empty.",
      }));
      titleInputRef.current.focus();
      formIsValid = false;
    } else if (!formData?.artist_slug) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        artist_slug: "Slug  Musician cannot be empty.",
      }));
      slugInputRef.current.focus();
      formIsValid = false;
    }
    if (!formData?.artist_email) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        artist_email: "Email cannot be empty.",
      }));
      emailRef.current.focus();
      formIsValid = false;
    } else if (!regex.test(formData?.artist_email)) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        artist_email: "Email format is incorrect.",
      }));
      emailRef.current.focus();
      formIsValid = false;
    }
    return formIsValid;
  }

  // api end
  // function start
  const handleBlurtitle = () => {
    if (!formData?.artist_slug) {
      generateSlug(formData?.artist_name);
    }
  };

  const generateSlug = async (artist_name) => {
    const slug = await slugGenerator(artist_name)
    setFormData((prevFormData) => ({
      ...prevFormData,
      artist_slug: slug,
    }));
  };

  const handleInputKeyDowntitle = (event) => {
    if (!formData?.artist_slug) {
      if (event.key === "Enter" || event.key === "Tab") {
        generateSlug(formData?.artist_name);
      }
    }
  };

  const handleAutoFillChangetitle = (event) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      artist_slug: event.target.value,
    }));
    setFormDataError((prevFormData) => ({
      ...prevFormData,
      [event.target.name]: "",
    }));
  };

  const handleBlurTitleEdit = () => {
    generateSlug(formData?.artist_slug);
  };

  const handleInput = async (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setFormDataError((prevFormData) => ({
      ...prevFormData,
      artist_name: "",
      artist_slug: "",
      artist_email: "",
      artist_type: ""
    }));
  }
  //Handle Image upload
  const handleCoverImageChange = (event) => {
    const selectedFile = event.target.files;
    if (selectedFile.length > 0) {
      const newFile = selectedFile[0];
      const reader = new FileReader();
      reader.onload = () => {
        setCoverImageFile(newFile);
      };
      reader.readAsDataURL(newFile);
    } else {
    }
  };


  const EditData = async () => {
    const response = await axios.get(`${musicianDefaultURL.editApi}/${id}`, { headers: headers });
    const result = response?.data;
    const editResult = result?.artist;
    if (response?.data?.status) {
      setFormData(editResult)
      setLoading(false);
    }
    else {
      console.error(result?.message)
      setLoading(false);
    }


  };

  // function end
  useEffect(() => {

    if (id) {
      EditData()
    }



    const labelEditData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
          {
            headers: headers,
            params: { source: "recordholder-artist" },
          }
        );
        setLabelDisplay(response?.data?.label_management || []);
      } catch (error) {
        console.error("Error fetching label display:", error);
      }
    };

    labelEditData()

  }, [withOutRefresh]);
  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={!id ? `${labelDisplay?.[1]?.title}` : `${labelDisplay?.[2]?.title}`} saveText={!id ? `${labelDisplay?.[10]?.title}` : `${labelDisplay?.[10]?.title}`} saveMethod={handleStore} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={!id ? `${labelDisplay?.[1]?.title}` : `${labelDisplay?.[2]?.title}`} />
            <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
            <input type="text" name="artist_name" value={formData?.artist_name} onChange={handleInput} placeholder="Artist " ref={titleInputRef} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} className="rs-input form-control-lg custom-placeholder  theme-text-color mb-3" />
            {formDataError?.artist_name && (<MessageBox text={`${formDataError?.artist_name}`} classname='errorred mb-2 d-block' />)}

            <MessageLabel text={labelDisplay?.[4]?.title} />
            <input type="text" name="artist_slug" id="artist_slug" value={formData?.artist_slug} onChange={handleAutoFillChangetitle} ref={slugInputRef} onBlur={handleBlurTitleEdit} placeholder="slug" className="mb-3 rs-input form-control-lg custom-placeholder  theme-text-color " />
            {formDataError?.artist_slug && (<MessageBox text={`${formDataError?.artist_slug}`} classname='errorred mb-2 d-block' />)}

            <MessageLabel text={labelDisplay?.[5]?.title} className="mandatorySimple" />
            <input type="text" name="artist_email" value={formData?.artist_email} ref={emailRef} onChange={handleInput} placeholder="Email" className="rs-input form-control-lg custom-placeholder  theme-text-color  mb-3" />
            {formDataError?.artist_email && (<MessageBox text={`${formDataError?.artist_email}`} classname='errorred mb-2 d-block' />)}
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[6]?.title} />
            <MessageLabel text={labelDisplay?.[7]?.title} />
            {id && <img src={formData?.image} alt="Image" className="thumbnails-images rounded-2 my-2 " />}
            <MessageSubHeading text={labelDisplay?.[7]?.sub_title} />
            <div className="mx-0 my-3 row">
              <div className="col-6 ps-0">
                <div className="imagedrop theme-border-color" >
                  <input type="file" ref={coverImageRef} onChange={(event) => handleCoverImageChange(event)} accept="image/*" className="opacity-0 w-100 h-100" key={coverImageFile ? coverImageFile : "inputKey"} />
                  <label className="theme-text-color position-absolute"><CameraRetroIcon className=" theme-text-color" /> </label>
                </div>
              </div>
              <div className="col-6 pe-0">
                <div>
                  {coverImageFile && (
                    <div className="imagedropcopy theme-border-color text-end">
                      <div className="row mx-0">
                        <div className="col-10 p-0 ">
                          <img src={URL?.createObjectURL(coverImageFile)} alt="Uploaded" className="thumbnails-upload-images" />
                        </div>
                        <div className="col-2 p-0" style={{ alignSelf: "center" }}>
                          <button onClick={() => setCoverImageFile(null)} type="button" className="bg-transparent theme-text-color"><IoClose className="custom-close-btn"></IoClose></button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Wrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[8]?.title} />
            <MessageLabel text={labelDisplay?.[9]?.title} />
            <textarea rows="5" type="text" name="description" value={formData?.description} onChange={handleInput} placeholder="Artist Description" className="rs-input form-control-lg custom-placeholder  theme-text-color " />
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}
export default AddPerformer;